import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainLayout from './components/layout/MainLayout.jsx';
import HomePage from './components/pages/Home.jsx';
import ScrollToTop from './components/common/ScrollToTop.jsx';
import About from './components/pages/About.jsx';
import Services from './components/pages/Product.jsx';
import Algorithm from './components/pages/Algorithm.jsx';
import LoansJV from './components/pages/Loans.jsx';
import Partner from './components/pages/PartnerWithUs.jsx';
import Disclaimer from './components/pages/Disclamer.jsx';
import Partners from './components/pages/Framchise.jsx';
import Contact from './components/pages/Contact.jsx';
import Gallery from './components/pages/Gallery.jsx';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route element={<MainLayout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/algorithm" element={<Algorithm />} />
          <Route path="/loans" element={<LoansJV />} />
          <Route path="/partner" element={<Partner />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/franchise" element={<Partners />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/gallery" element={<Gallery />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
